var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.69458C16 5.24686 15.5523 5.69458 15 5.69458H12C11.4477 5.69458 11 5.24686 11 4.69458V2.69458C11 2.1423 11.4477 1.69458 12 1.69458H15C15.5523 1.69458 16 2.1423 16 2.69458V4.69458Z",
    fill: "#95A5B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.4844C16 12.0367 15.5523 12.4844 15 12.4844H12C11.4477 12.4844 11 12.0367 11 11.4844V9.48438C11 8.93209 11.4477 8.48438 12 8.48438H15C15.5523 8.48438 16 8.93209 16 9.48438V11.4844Z",
    fill: "#95A5B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05223 9.99911L7.03135 8.0354",
    stroke: "#95A5B6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03126 4.81346L8.99493 3.97461",
    stroke: "#95A5B6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7C5 7.55228 4.55228 8 4 8H1C0.447715 8 0 7.55228 0 7V5C0 4.44772 0.447715 4 1 4H4C4.55228 4 5 4.44772 5 5V7Z",
    fill: "#95A5B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeIcon);
export default __webpack_public_path__ + "static/media/tree-icon.125943092b55618d9218ca190f2ef7bf.svg";
export { ForwardRef as ReactComponent };